import { z } from 'zod';
import { TypedApiClient } from '../index';
import { schemas } from '../../generated/api-client';
import { apiPath } from '../path';

// Import schemas from generated
const { PrintTemplateFirestoreResponse, CreatePrintTemplateDto, UpdatePrintTemplateDto } = schemas;

// Re-export schemas for consumers
export const PrintTemplateResponseSchema = PrintTemplateFirestoreResponse;
export const CreatePrintTemplateSchema = CreatePrintTemplateDto;
export const UpdatePrintTemplateSchema = UpdatePrintTemplateDto;

export const DeleteResponseSchema = z
  .object({
    message: z.string(),
  })
  .strict();

// Type exports
export type PrintTemplateResponse = z.infer<typeof PrintTemplateResponseSchema>;
export type CreatePrintTemplate = z.infer<typeof CreatePrintTemplateSchema>;
export type UpdatePrintTemplate = z.infer<typeof UpdatePrintTemplateSchema>;

// API factory function
export function createPrintTemplatesApi(client: TypedApiClient) {
  return {
    getPrintTemplates: (params?: { type?: string }): Promise<PrintTemplateResponse[]> => {
      return client.get('/print-templates', {
        params: params as Record<string, unknown>,
        responseSchema: z.array(PrintTemplateResponseSchema),
      });
    },

    getPrintTemplatesByTypeAndStore: (params: {
      type: string;
      storeId?: string;
    }): Promise<PrintTemplateResponse[]> => {
      return client.get('/print-templates/by-type-and-store', {
        params: params as Record<string, unknown>,
        responseSchema: z.array(PrintTemplateResponseSchema),
      });
    },

    createPrintTemplate: (data: CreatePrintTemplate): Promise<PrintTemplateResponse> => {
      CreatePrintTemplateSchema.parse(data);
      return client.post('/print-templates', {
        data,
        responseSchema: PrintTemplateResponseSchema,
      });
    },

    updatePrintTemplate: (
      id: string,
      data: UpdatePrintTemplate,
    ): Promise<PrintTemplateResponse> => {
      return client.put(apiPath`/print-templates/${id}`, {
        data,
        responseSchema: PrintTemplateResponseSchema,
      });
    },

    deletePrintTemplate: (id: string): Promise<z.infer<typeof DeleteResponseSchema>> => {
      return client.delete(apiPath`/print-templates/${id}`, {
        responseSchema: DeleteResponseSchema,
      });
    },
  };
}
